import React from 'react';
import { Card } from './ui/Card';
import { LayoutGrid, Layers, Leaf, Waves, Droplets, Home } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <LayoutGrid className="w-8 h-8 text-teal" data-id="element-169" />,
    title: 'Paver Installation',
    description: 'Driveways, patios, walkways, and pool decks built to last.'
  }, {
    icon: <Layers className="w-8 h-8 text-teal" data-id="element-170" />,
    title: 'Travertine',
    description: 'Premium natural stone surfaces for a high-end, cool-touch finish.'
  }, {
    icon: <Leaf className="w-8 h-8 text-teal" data-id="element-171" />,
    title: 'Artificial Turf',
    description: 'Low-maintenance, year-round green that saves water and looks flawless.'
  }, {
    icon: <Waves className="w-8 h-8 text-teal" data-id="element-172" />,
    title: 'Pool Decks & Resurfacing',
    description: 'Transform your old concrete into a stunning stone oasis.'
  }, {
    icon: <Droplets className="w-8 h-8 text-teal" data-id="element-173" />,
    title: 'Pool Plastering',
    description: "Refresh your pool's interior with premium plaster and pebble finishes.",
    isNew: true
  }, {
    icon: <Home className="w-8 h-8 text-teal" data-id="element-174" />,
    title: 'Backyard Transformations',
    description: 'Full outdoor living projects from design to final installation.'
  }];
  return <section id="services" className="py-20 md:py-28 bg-travertine" data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-extrabold font-heading text-charcoal mb-6 tracking-tight" data-id="element-178">
            Premium Hardscaping Services
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-179">
            We specialize in high-end outdoor living transformations. From
            custom paver driveways to complete backyard renovations, we deliver
            exceptional craftsmanship.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-180">
          {services.map((service, index) => <Card key={index} className="bg-white border-none shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group" data-id="element-181">
              <div className="p-8" data-id="element-182">
                <div className="w-16 h-16 bg-sand/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-183">
                  {service.icon}
                </div>
                <div className="flex items-center gap-3 mb-3" data-id="element-184">
                  <h3 className="text-xl font-bold font-heading text-charcoal" data-id="element-185">
                    {service.title}
                  </h3>
                  {service.isNew && <span className="bg-teal/10 text-teal text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-186">
                      New
                    </span>}
                </div>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-187">
                  {service.description}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}